<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import CVComponent from "@/component/project/CVComponent.vue";

@Component({
  components: {CVComponent, NavBar}
})
export default class CVView extends Vue {

}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <CVComponent/>
  </div>
</template>

<style scoped>
.view-container {
  margin-left: 80px;
  height: 100vh;
  background-color: var(--background-color);
  overflow-y: auto;
}
</style>